import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JiraServicedeskQueueAri } from '@atlassian/ari/jira-servicedesk/queue';
import parameters from './ui/__generated__/HorizontalNavQueueInnerQuery$parameters';
import type { HorizontalNavQueueInnerQuery } from './ui/__generated__/HorizontalNavQueueInnerQuery.graphql';

const NAVIGATION_ITEMS_PAGE_SIZE = 75;

type HorizontalNavQueueEntrypointComponent = EntryPointComponent<
	{
		horizontalNavQueueQuery: HorizontalNavQueueInnerQuery;
	},
	{},
	{},
	{}
>;

export const horizontalNavQueueEntrypoint: EntryPoint<
	HorizontalNavQueueEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<HorizontalNavQueueEntrypointComponent>(
		/* webpackChunkName: "async-horizontal-nav-queue-inner-entrypoint" */ './ui/HorizontalNavQueueInner.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({
		context: { match, query },
		tenantContext: { activationId, cloudId },
	}: EntryPointRouteParams) => {
		const queueId = match.params.queueId;
		let { projectKey, projectId } = getProjectKeyId(match, query);
		projectKey = projectKey ?? '';
		projectId = projectId ?? '';
		const projectIdOrKey = projectId || projectKey;

		const queueAri = queueId
			? JiraServicedeskQueueAri.create({
					siteId: cloudId,
					queueId: queueId || '',
					activationId,
				}).toString()
			: '';

		const containerNavigationInput = queueAri
			? { scopeId: queueAri }
			: { projectKeyQuery: { cloudId, projectKey } };
		return {
			queries: {
				horizontalNavQueueQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectIdOrKey,
						containerNavigationInput,
						first: NAVIGATION_ITEMS_PAGE_SIZE,
					},
				},
			},
		};
	},
});
